export const baseURL = "https://promotiontalent-gebdhfcca6dxewgt.uaenorth-01.azurewebsites.net/api";

export const REGISTER = "register";
export const LOGIN = "login";
export const LOGOUT = "logout";


export const USERS = "users";
export const USER = "user";

// FOLLWERS AND FOLLOWING
export const FOLLOWERS = "followers";
export const FOLLOWING = "following";
export const FOLLOW = "follow";
export const UNFOLLOW = "unfollow";

// VIDEOS
export const VIDEOS = "videos";
export const VIDEO = "video";
export const LIKERS = "likers";
export const LIKES = "toggle-like";

// REVIEWS
export const REVIEWS = "reviews";
export const BESTTALENTS = "bestTalents";

// CERTIFICATES
export const CERTIFICATES = "achievements";

// NOTIFICATIONS
export const NOTIFICATIONS = "notifications";
export const MARKALLREAD = "mark-all-read";

// OFFERS
export const OFFER = "offer";
export const OFFERS = "offers";
export const ALLOFFERS = "allOffers";
export const ALLTALENTOFFERS = "talent/offers";


